/**
 * @file onboardingSteps.js
 * @description Tutorial contextual (spotlight) del onboarding inicial. Lista ORDENADA:
 * OnboardingTour.js muestra el primero cuyo `isActive` sea true. Agregar un tutorial
 * nuevo más adelante es solo agregar una entrada acá — no hace falta tocar el componente.
 *
 * Cada `target` es el selector CSS de un elemento que YA existe en algún banner
 * (EmailVerificationBanner.js / ActivationBanner.js) — el spotlight apunta al botón real
 * que resuelve el paso, no navega ni duplica esa acción.
 */

export const ONBOARDING_STEPS = [
    {
        key: 'verify_email',
        stepNumber: 1,
        target: '#onboarding-verify-email',
        titleKey: 'onboardingTour.verifyEmail.title',
        contentKey: 'onboardingTour.verifyEmail.content',
        // Mismo criterio que EmailVerificationBanner.js: aplica a cualquier rol (en la
        // práctica solo los owners llegan a pending_verification, ver tarea 027).
        isActive: (user, business) => !!user && !user.email_verified_at,
    },
    {
        key: 'setup_business',
        stepNumber: 2,
        target: '#onboarding-setup-business',
        titleKey: 'onboardingTour.setupBusiness.title',
        contentKey: 'onboardingTour.setupBusiness.content',
        // Mismo guard que ActivationBanner.js:17 — los colaboradores nunca ven ese banner.
        isActive: (user, business) => !!user && user.role === 'owner'
            && !!user.email_verified_at && !user.is_setup_complete,
    },
    {
        key: 'subscribe',
        stepNumber: 3,
        target: '#onboarding-subscribe',
        titleKey: 'onboardingTour.subscribe.title',
        contentKey: 'onboardingTour.subscribe.content',
        isActive: (user, business) => !!user && user.role === 'owner' && !!user.is_setup_complete
            && !['active', 'trialing'].includes(business?.subscription_status),
    },
];
